<template>
  <div class="library">
    <avue-crud ref="crud" :option="tableOption" :data="tableData" :page.sync="tablePage">
      <template slot="menuLeft">
        <div class="btns">
          <el-upload :file-list="fileList" :http-request="uploadRing" :show-file-list="false">
            <el-button size="small" type="primary"> 上传铃声 </el-button>
          </el-upload>
          <el-upload :file-list="fileList" :http-request="uploadNavVioce" :show-file-list="false">
            <el-button size="small" type="primary"> 上传导航语音 </el-button>
          </el-upload>
        </div>
      </template>
      <template slot="trial" scope="{row}">
        <i class="el-icon-headset icon" @click="doTrial(row)"></i>
      </template>
      <template slot="del" scope="{row}">
        <i class="el-icon-delete icon" @click="doDel(row)"></i>
      </template>
    </avue-crud>
  </div>
</template>

<script>
import {
  getAudioListApi,
  addAudioApi,
  delAudioApi,
} from '@/api/call-system/call-manage/rule-config';

export default {
  data() {
    return {
      fileList: [], // 文件列表
      tableData: [], // 表格数据
      // 表格分页信息
      tablePage: {
        total: 0,
      },
      // 表格选项
      tableOption: {
        height: 'auto',
        calcHeight: 'auto',
        border: true,
        refreshBtn: false,
        columnBtn: false,
        searchShowBtn: false,
        addBtn: false,
        menu: false,
        dialogClickModal: false,
        column: [
          {
            label: '名称',
            prop: 'fixme1',
          },
          {
            label: '类型',
            prop: 'fixme2',
          },
          {
            label: '试听',
            prop: 'trial',
            slot: true,
          },
          {
            label: '删除',
            prop: 'del',
            slot: true,
          },
        ],
      },
    };
  },
  created() {
    this.getList();
  },
  methods: {
    /* 获取音频文件列表 */
    getList() {
      Promise.resolve([
        { fixme2: '铃声', fixme1: 'ring' },
        { fixme2: '导航语音', fixme1: 'welcome' },
      ]).then((data) => {
        this.tableData = data;
      });
      /* getAudioListApi().then(({ data }) => {
        this.tableData = data;
      }); */
    },
    /* 试听->实际是下载 */
    doTrial(row) {
      window.open(row.file.link, row.file.originalName); // fixme
    },
    /* 删除 */
    doDel(row) {
      this.$confirm('确认删除？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return delAudioApi({
            id: row.id,
          });
        })
        .then(() => {
          this.$message.success('操作成功!');
        });
    },
    /* 上传铃声 */
    uploadRing(file) {
      this.doUpload('ring', file);
    },
    /* 上传导航语音 */
    uploadNavVioce(file) {
      this.doUpload('navVioce', file);
    },
    /* 上传 */
    doUpload(type, file) {
      return; // fixme 目前没接口，所以先屏蔽，免得报错
      let fd = new FormData();
      fd.append('file', file.file);
      fd.append('type', type);
      addAudioApi(this.formData, {
        showLoading: { text: '处理中...' },
      }).then(() => {
        this.$message.success('操作成功!');
        this.getList();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.btns {
  display: flex;
}

.icon {
  cursor: pointer;
}
</style>
